export default {
  welcome: {
    title: ["We are", "Awesome &", "Beautiful"],
    fullTitle: "We are Awesome & Beautiful",
    tag:
      "Nurturing and encouraging the less privileged to keep dreaming, believing and start acting."
  },
  nav: [
    { name: "M I S S I O N", viewId: "mission", navId: "n-mission" },
    { name: "A B O U T", viewId: "about", navId: "n-about" },
    { name: "I M P A C T", viewId: "impact", navId: "n-impact" },
    { name: "W O R K", viewId: "work", navId: "n-work" },
    { name: "T E A M", viewId: "team", navId: "n-team" }
  ],
  mission: [
    {
      icon: "empower",
      title: "Empowerment",
      description:
        "By creating educative and creative platforms that will empower the deprived and disadvantaged and enable them",
      showMore: false,
      more:
        "to reach their full potential. We believe that everyone has the power to unlock their limitless capabilities and education is a driving factor in its’ achievement. The future, so closely sort after, relies upon the profound impact citizens apply to the world around them. With the opportunity therefore, individuals – especially the disadvantaged have access to dream, learn and become."
    },
    {
      icon: "food",
      title: "Food Security",
      description:
        "To tackle poverty & achieve food security for the deprived. The availability & access to food is deemed necessary",
      showMore: false,
      more:
        "for the thorough growth & development of every individual. As poverty affects food stability, we focus on delivering the know-how to enable the disadvantaged provide for their family and consistently thrive."
    },
    {
      icon: "health",
      title: "Well-being",
      description:
        "Ensure healthy lives and promote well-being particularly for the poor. At the core of everyday living is having a good health",
      showMore: false,
      more:
        "condition that supports balanced growth, development and fulfillment of desires. Much more than being healthy is the need to maintain optimum health conditions in order to handle stress and remain present to support families."
    },
    {
      icon: "teamwork",
      title: "Research & Collaboration",
      description:
        "We understand that when we come together to improve the welfare of others, our collective resources enable us ",
      showMore: false,
      more:
        "reach more people. Through extensive research and the use of analytical tools, we are able to deduce adequate data and innovate ideas that drive our goals.  It is therefore paramount for us to strategically partner with like-minded organizations to continually effect change all over the world."
    }
  ],
  impact: [
    {
      stat: "100+",
      description: "children got school supplies"
    },
    {
      stat: "150",
      description: "vision board journals distributed"
    },
    {
      stat: "500+",
      description: "Our Daily Bread illustrative books distributed"
    },
    {
      stat: "150+",
      description: "children provided with food supplies"
    }
  ],
  activities: [
    {
      img: "/static/imgs/education.png",
      title: "Educational & Transformational Programs",
      subText: "In the words of Nelson Mandela",
      hasQuote: true,
      quote:
        "Education is the most powerful weapon which you can use to change the world",
      body: {
        goal:
          "To champion and invest in quality concepts and compelling programs to help inspire a love of learning and provide the less privileged with the skills to succeed in a global economy",
        challenge:
          "Attending school is not the same as learning. Though tremendous progress have been made in education over the past 15 years, millions of students are in school but learning very little. Worldwide, there are about 153 million orphans and over 600 million children living with disabilities. These young people barely get the right opportunity or platform to hone their capabilities.",
        opportunity:
          "An investment in education is an investment in the future. Based on the premise that individuals can find their identity/ purpose through connections to community and the world at large, we believe there are limitless opportunities for young people to grow their talent. It takes a courageous person and enabling environment to work through any disability and become all they dream to be.",
        focus:
          "These programs are focused on young people in our sub-divisions: orphanages / the disabled, in IDPs and poor rural communities.",
        strategy:
          "Our holistic model enables us use a transformative approach to a process of self actualisation and learning. We do this by keenly researching on dire areas of need and create solutions that can be accepted and sustained. We are committed to partnering with like-minded organizations to provide sound education systems with better information, tools and concepts that can help improve learning.",
        otherStrategy:
          "We also work in close partnerships with various disability services aimed at specific groups and needs, not a one-size-fits-all approach in order to see any disabled person thrive and own their uniqueness!"
      }
    },
    {
      img: "/static/imgs/welfare.png",
      title: "Welfare / Health Support",
      subText:
        "The goal is to create an immediate impact in the lives of disadvantaged people.",
      body: {
        goal:
          "We aim to create an immediate impact with basic, social and health amenities in poor rural communities.",
        challenge:
          "The inadequate basic / health facilities in poor communities have led to avoidable deaths.",
        opportunity:
          "There is a potential for greatness in everyone. However they are greatly influenced by their community around them. We are determined to tackle the challenge by developing creative and social mediums to reach out to poor rural communities, teach new values and concepts and provide basic amenities that will improve their lives.",
        focus: "Rural communities, Widows, hospice",
        strategyList: [
          "Partnership with health awareness bodies/organizations.",
          "Provide basic amenities and knowledge on financial principles and tools.",
          "Teach on the principles of productivity and sustainability in their various fields of trade or business.",
          "Health drives to homes for the old and critically ill."
        ]
      }
    },
    {
      img: "/static/imgs/partner.jpg",
      title: "Global Partnership",
      subText:
        "In achieving our goal, we know our resources alone are not enough. So, we collaborate with individuals and organizations to continually promote creative lives.",
      body: {
        other:
          "In achieving our goal, we know our resources alone are not enough. So, we collaborate with individuals and organizations to continually promote creative lives. These partnerships involve careful selections across a number of organizations. Our partnerships also require open conversations; maximum cooperation and the keen interest to drive positive impacts; which are harnessed in order to see the change we desire.",
        other2:
          "In partnership with Save the Deaf and Endangered Language Initiatives (S-DELI) on a project branded Beauty Beyond Speech (BBS). It is advocating for the safety of deaf girls as part of our contribution to the campaign against Violence against Women (VAW). Periodically, a deaf school or organization is selected to work with / impact under this project.",
        isContact: true
      }
    }
  ],
  facts: [
    {
      title: "1.75 million",
      description:
        "children in Nigeria are orphans due to natural disasters, poverty, health needs or war",
      tweet:
        "https://twitter.com/intent/tweet?text=1.75%20million%20children%20in%20Nigeria%20are%20orphans%20due%20to%20natural%20disasters,%20poverty,%20health%20needs%20or%20war%20via%20@wuraalese"
    },
    {
      title: "91.6 million",
      description: "people in Nigeria are living below $1 a day",
      tweet:
        "https://twitter.com/intent/tweet?text=91.6%20million%20people%20in%20Nigeria%20are%20living%20below%20$1%20a%20day@wuraalese"
    }
  ],
  team: [
    {
      img: "/static/imgs/aghogho.jpg",
      title: "Aghogho Odibo",
      role: "Chair & Trustee"
    },
    {
      img: "/static/imgs/john.jpg",
      title: "John E. Owotorufa",
      role: "Lead Operations & Trustee"
    },
    {
      img: "/static/imgs/richard.jpeg",
      title: "Richard Odibo",
      role: "Trustee"
    },
    {
      img: "/static/imgs/lamide.jpg",
      title: "Olamide Wilson",
      role: "Lead Creative Content & Media"
    },
    {
      img: "/static/imgs/bisola.jpg",
      title: "Bisola Aladenika",
      role: "Finance & Research Officer"
    },
    {
      img: "/static/imgs/philo.jpeg",
      title: "Philomina Temitayo",
      role: "Member & Advisory"
    },
    {
      img: "/static/imgs/funto.jpg",
      title: "Obafunto AyinOluwa",
      role: "Advisory"
    }
  ],
  contribute: [
    {
      icon: "share",
      title: "Spread your love with words",
      description: "Your loving message will be shared at our events.",
      btn: "S H A R E",
      modalId: "#shareModal"
    },
    {
      icon: "network",
      title: "Become a member / partner",
      description: "Join us to lift others. Inspire. Act!",
      btn: "J O I N",
      moreText: "U S",
      modalId: "#joinModal"
    },
    {
      icon: "give",
      title: "Every contribution counts",
      description: "Make donations where is close to your heart.",
      btn: "D O N A T E",
      modalId: "#donateModal"
    }
  ],
  about: {
    first:
      "For Aghogho, the desire to find ways to help others started when she was quite young. Greatly encouraged by her family especially her parents, she grew up giving out her gently used items to others in need. Escalating towards those she did not even know, she sought out orphanages to spend time volunteering during her vacations.",
    second: [
      {
        year: "2008",
        text:
          "Aghogho started volunteering and working with organisations in her hometown to improve the lives of the deprived and disadvantaged focusing more on orphanages."
      },
      {
        year: "2010",
        text:
          "she became the Head of Orphanages and Special Events Coordinator of the NGO, Smile Care Initiative (where she still participates in)."
      },
      {
        year: "2015",
        text:
          "just like the first projects started in orphanages, Aghogho and her family learned about more people who needed basic amenities and sought to reach out to select groups in ways to create lifetime memories. Also, awesome and Beautiful was born."
      },
      {
        year: "2018",
        text:
          "full company registration and induction of all board members. Official work commenced under the name ",
        sub: "Awesome and Beautiful"
      }
    ],
    others: [
      {
        istitleMandateAndFocus: true,
        text:
          "Our objective and name as an organization comes from the need to pass a message across to both the deprived and everyone else. Our message being “Our birth, privileges or none and outward appearance, should not solely determine our life’s outcome, because we all stem from the image and likeness of God”. Hence, the need to constantly remind ourselves of who we are- fearfully, marvellously and wonderfully made.",
        isList: true,
        list: [
          "To show the power of love through God’s perspective by addressing the needs (realistic & quantifiable) of the deprived and disadvantaged.",
          "To raise individuals who will creatively walk in confidence and find the good in every challenge life throws at them by ​nurturing and encouraging them to keep dreaming, believing and start acting.",
          "To create fresh, exciting and memorable experiences for the disadvantaged."
        ]
      },
      {
        title: "V I S I O N",
        isList: false,
        text:
          "To be a leading and God-fearing NGO dedicated to creating sustainable opportunities for the deprived and disadvantaged to have new experiences, spreading our ​tireless trust that anything is possible if we believe we can and deserve to​."
      },
      {
        title: "V A L U E S",
        isList: false,
        text:
          "Faith, Love, Lifelong learning, Positivity Mentality, Compassion, Responsibility and Resilience."
      },
      {
        title: "A I M",
        isList: false,
        text:
          "To be the light of love, hope and serenity that shines our brightness to illuminate hearts and raise giants in Africa and on global platforms."
      },

      {
        istitleProject: true,
        isList: false,
        text:
          "We operate by running Major and Minor projects. Major Projects involve the Events we organize (or partner with other organizations) for the calendar year. They receive full involvement and hands on work. Minor projects involve donations and grants to individuals or other organizations but full participation is not obligatory.",
        text2:
          "All projects run in phases, have their goals, targets and approach which guide resource allocation. Projects are subject to measurement and evaluation to maintain learning, modification, progress and alignment.",
        moreInfo: true
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/data/data.js